/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The type of service:
 *   * IN_USE
 *   * IN_USE_WITH_RESTRICTIONS
 *   * STOPPED
 *   * UNDER_CONSTRUCTION
 *   * PLANNING_STAGE
 */
export enum ServiceType {
  IN_USE = 'IN_USE',
  IN_USE_WITH_RESTRICTIONS = 'IN_USE_WITH_RESTRICTIONS',
  STOPPED = 'STOPPED',
  UNDER_CONSTRUCTION = 'UNDER_CONSTRUCTION',
  PLANNING_STAGE = 'PLANNING_STAGE'
}
